import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';
import {OutlinedCard, OutlinedCardProps, Typography, VerticalSpacer} from '..';
import classNames from 'classnames';

const Styled = styled.div``;
const HR = styled.div`
    border-bottom: 1px solid ${(p) => p.theme.palette.neutral.steel};
`;

const OutlinedCards = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .flex-column {
        margin-bottom: 32px;
    }

    .ue-outlined-card {
        margin-right: 32px;
        min-width: 255px;
        min-height: unset;
        
        margin-right: unset;
        width: 100%;
        max-width: unset;
    }

    .flex-column .flex-column-inner {
            margin-right: 32px;
        }

    .card-content{
        align-self: flex-start;
    }

    ${(p) => p.theme.breakpoints.up('lg')} {
        .flex-column {
            width: 25%;
        }        
    }

    ${(p) => p.theme.breakpoints.down('md')} {
        .flex-column {
            flex-grow: 1;
            width: 50%;
        }
    }

    ${(p) => p.theme.breakpoints.down('xs')} {
        .flex-column {
            width: 100%;
        }   
        .flex-column .flex-column-inner {
            margin-right: 0px;
        }     
    }


    .hidden {
        display: none;
    }
`;

export interface NoSearchResultsBlockProps {
    accentColor?: AccentColorOptions;
    searchKeyword?: string;
    noResultsText?: string;
    noResultsTextHidden?: boolean;
    suggestedLinksLabel?: string;
    outlinedCards?: OutlinedCardProps[];
}

export const NoSearchResultsBlock = (props: NoSearchResultsBlockProps): JSX.Element => {
    const {
        searchKeyword,
        noResultsText = 'There are no results for',
        suggestedLinksLabel = 'Suggested Links',
        outlinedCards,
        noResultsTextHidden
    } = props;

    return (
        <Styled>
            <div className={classNames({hidden: noResultsTextHidden})}>
                <Typography variant="h2">
                    {noResultsText} “{searchKeyword}”
                </Typography>
                <VerticalSpacer variant="eyebrow" />
                <HR />
            </div>
            <VerticalSpacer variant="eyebrow" />
            {outlinedCards && (
                <>
                    <VerticalSpacer variant="eyebrow" />
                    <Typography variant="h3" >
                        {suggestedLinksLabel}
                    </Typography>
                    <VerticalSpacer variant="eyebrow" />
                </>
            )}
            {!outlinedCards && <VerticalSpacer variant="heading" />}

            <OutlinedCards>
                {outlinedCards?.map((outlinedCard, i) => {
                    return (
                        <div className="flex-column" key={i}>
                            <div className="flex-column-inner" >
                                <OutlinedCard
                                    {...outlinedCard}
                                    topVerticalSpacing={8}
                                    fillParentSize={true}
                                    groupedHeight={true}
                                    showBorder={true}
                                />
                            </div>
                        </div>
                    );
                })}
            </OutlinedCards>
        </Styled>
    );
};
